import React from 'react';
import { HashRouter as Router, Route, Switch, Link, withRouter } from 'react-router-dom';
import { Breadcrumb, Alert } from 'antd';


const breadcrumbNameMap = {
    "/admin/add": "Add Class",
    "/admin/editclass": "Edit Class",
    "/admin/grade": "Manage",
    "/admin/register": "Register",
    "/admin/registerMultiple": "Multiple Registration",
    "/admin/assigncert": "Assign Certification",
    "/admin/searchStudentHistory": "Search Student History",
    "/admin/email": "Email Class",
    "/admin/change": "Change Class",
    "/admin/payment": "Payment",
    "/admin/addemployer": "Employer",
    "/admin/merge": "Merge",
    "/admin/addescc": "Add ESCC",
    "/admin/assignescc": "Assign ESCC",
    "/admin/addecrt": "Add Civil Rights Certificate",
    "/admin/assignecrt": "Assign Civil Rights Certificate",
    "/admin/import": "Import Students",
    "/admin/editattendee": "Edit Students",
    "/registry": "  /    Registry",
    "/CRregistry": "  /    Civil Rights Registry",
};

const Home = withRouter((props) => {
    const { location } = props;
    const pathSnippets = location.pathname.split('/').filter(i => i);
    const extraBreadcrumbItems = pathSnippets.map((_, index) => {
        const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
        return (
            <Breadcrumb.Item key={url}>
                <Link style={{ color: 'white' }} to={url}>
                    {breadcrumbNameMap[url]}
                </Link>
            </Breadcrumb.Item>
        );
    });

    var admin = false;
    if (typeof extraBreadcrumbItems[1] !== 'undefined') {
        admin = extraBreadcrumbItems[1].key == '/admin/admin';
    }

    if (extraBreadcrumbItems[0].key == '/login' || admin) {
        console.log("here");
        return (
            <div className="inactiveNav" style={{ float: 'left' }}>
                <h4 className="pull-left" style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                    {<Link style={{ color: 'white' }} to="/admin/admin">Main Menu</Link >}
                </h4>
            </div>)
    }
    else {
        return (

            <div className="inactiveNav" style={{ float: 'left' }}>
                <h4 className="pull-left" style={{ paddingLeft: '20px' }}>
                    {<Link style={{ color: 'white' }} to="/admin/admin" >Main Menu</Link >}
                    {extraBreadcrumbItems}
                </h4>
            </div>);
    }
});

export default Home;



// WEBPACK FOOTER //
// ./src/Breadcrumbs.js